import * as React from 'react';
import styles from './styles.module.scss';
import { CCDisplay } from 'components';
import { isNil } from 'lodash-es';
import { CancellationFee } from 'AppClient/api/Bookings';
import { BookingCreditCard, CreditCard } from 'app-types';
import { getPriceWithCurrencyText } from 'utils/financeUtils';

interface Props {
	cancellationFee: CancellationFee;
	creditCard?: BookingCreditCard | CreditCard;
}

const ChargableText: React.FC<Props> = ({ cancellationFee, creditCard }) => {
	const {
		chargedPercentages,
		chargedFeeAmountInCustomerCurrency,
		customerCurrencySymbol,
	} = cancellationFee;
	const valueText = !isNil(chargedPercentages)
		? `${chargedPercentages}%`
		: getPriceWithCurrencyText(chargedFeeAmountInCustomerCurrency, customerCurrencySymbol);
	return (
		<>
			<div className={styles.chargableTextTitle}>
				This reservation is chargeable as per terms and conditions of the service partner.
			</div>
			{!creditCard && (
				<div className={styles.chargableTextInfo}>
					You will be charged {valueText} of your reservation.
				</div>
			)}
			{creditCard && (
				<>
					<div className={styles.chargableTextInfo}>
						You will be charged {valueText} of your reservation from the credit card
						used for booking:
					</div>
					<div className={styles.chargableTextCard}>
						<CCDisplay creditCard={creditCard} />
					</div>
				</>
			)}
		</>
	);
};
export default ChargableText;
